module.exports = __webpack_public_path__ + "img/panelView_strong_1_3.762aa8cf.png";